// Pure Generated Speaking Hub for Week 33
export const speakingHub = {
  talkshow_video: {
    video_id: "corridor_safety_w33",
    title: "School Corridor Safety & Responsibility"
  },
  info_exchange_cards: {
    audio_url: "/audio/week33/exam_intro_S2.mp3",
    table_a: {
      title: "Tom's Accident",
      subtitle: "Candidate's Question Card (Ask Examiner)",
      person: "Tom",
      fields: [
        {
          id: "field_a1",
          label: "where / get injured?",
          cue_word: "where",
          value: "?",
          is_missing: true,
          cue_prompt: "where / get injured?",
          grammar_scaffold: "Where did Tom get injured?",
          acceptable_questions: [
            "Where did Tom get injured?",
            "Where did Jake help his friend?",
            "Where did Jake help Tom?",
            "Where did he get injured?",
            "Where was Tom injured?",
            "Where did he get hurt?",
            "Where did he slip?",
            "Where did the accident happen?"
          ],
          nova_reply: "Tom got injured in the main school corridor near the science lab, and Jake helped him there.",
          audio_url: "/audio/week33/info_exchange_a1_model.mp3",
          model_audio_url: "/audio/week33/info_exchange_a1_model.mp3",
          reply_audio_url: "/audio/week33/info_exchange_reply_1.mp3"
        },
        {
          id: "field_a2",
          label: "what / hurt?",
          cue_word: "what",
          value: "?",
          is_missing: true,
          cue_prompt: "what / hurt?",
          grammar_scaffold: "What did Tom hurt?",
          acceptable_questions: [
            "What did Tom hurt?",
            "What did he hurt?",
            "Which part of his body did he hurt?",
            "What was hurt?"
          ],
          nova_reply: "Tom hurt his right knee when he fell on the wet floor.",
          audio_url: "/audio/week33/info_exchange_a2_model.mp3",
          model_audio_url: "/audio/week33/info_exchange_a2_model.mp3",
          reply_audio_url: "/audio/week33/info_exchange_reply_2.mp3"
        },
        {
          id: "field_a3",
          label: "when / accident happen?",
          cue_word: "when",
          value: "?",
          is_missing: true,
          cue_prompt: "when / accident happen?",
          grammar_scaffold: "When did the accident happen?",
          acceptable_questions: [
            "When did the accident happen?",
            "When did Tom slip?",
            "What time did the accident happen?",
            "When did he fall down?"
          ],
          nova_reply: "It happened this morning right after science class.",
          audio_url: "/audio/week33/info_exchange_a3_model.mp3",
          model_audio_url: "/audio/week33/info_exchange_a3_model.mp3",
          reply_audio_url: "/audio/week33/info_exchange_reply_3.mp3"
        },
        {
          id: "field_a4",
          label: "who / helped Tom?",
          cue_word: "who",
          value: "?",
          is_missing: true,
          cue_prompt: "who / helped Tom?",
          grammar_scaffold: "Who helped Tom?",
          acceptable_questions: [
            "Who helped Tom?",
            "Who helped Tom immediately?",
            "Who helped him?",
            "Who stopped to help?"
          ],
          nova_reply: "Jake stopped walking and called the school nurse right away.",
          audio_url: "/audio/week33/info_exchange_a4_model.mp3",
          model_audio_url: "/audio/week33/info_exchange_a4_model.mp3",
          reply_audio_url: "/audio/week33/info_exchange_reply_4.mp3"
        },
        {
          id: "field_a5",
          label: "how / feel now?",
          cue_word: "how",
          value: "?",
          is_missing: true,
          cue_prompt: "how / feel now?",
          grammar_scaffold: "How does Tom feel now?",
          acceptable_questions: [
            "How does Tom feel now?",
            "How does he feel now?",
            "How is Tom feeling now?",
            "How is he feeling now?",
            "Is Tom feeling better now?"
          ],
          nova_reply: "Tom feels much better now and his knee is recovering well.",
          audio_url: "/audio/week33/info_exchange_a5_model.mp3",
          model_audio_url: "/audio/week33/info_exchange_a5_model.mp3",
          reply_audio_url: "/audio/week33/info_exchange_reply_5.mp3"
        }
      ]
    },
    table_b: {
      title: "Jake's First Aid Action",
      subtitle: "Card 1: Information Card — Answer Examiner Nova's Questions",
      person: "Jake",
      fields: [
        {
          id: "field_b1",
          topic: "where / help?",
          cue_prompt: "where / help friend?",
          cue_word: "where",
          short_label: "where / help?",
          label: "where / help friend?",
          value: "Near the science room.",
          nova_question: "Where did Jake help his friend?",
          audio_url: "/audio/week33/info_exchange_q1.mp3",
          answer_audio_url: "/audio/week33/info_exchange_b1_answer.mp3",
          hint: "Check your card — where was Jake standing when he helped?",
          acceptable_answers: [
            "Near the science room.",
            "Near the science room",
            "Near the science lab.",
            "Near the science lab",
            "He helped him near the science room.",
            "He helped his friend near the science room.",
            "Jake helped his friend near the science room.",
            "Jake helped Tom near the science room.",
            "Jake helped him near the science room.",
            "In the school corridor near the science room.",
            "In the school corridor near the science lab.",
            "In the school corridor.",
            "In the corridor near the science room.",
            "Where did Jake help his friend?",
            "Where did he help his friend?",
            "Where did Jake help Tom?"
          ]
        },
        {
          id: "field_b2",
          topic: "what items / use?",
          cue_prompt: "what items / nurse use?",
          cue_word: "what",
          short_label: "what items / use?",
          label: "what items / nurse use?",
          value: "A clean bandage and a cold pack.",
          nova_question: "What first aid items did the nurse use?",
          audio_url: "/audio/week33/info_exchange_q2.mp3",
          answer_audio_url: "/audio/week33/info_exchange_b2_answer.mp3",
          hint: "Look at your card — two items are listed.",
          acceptable_answers: [
            "A clean bandage and a cold pack.",
            "A clean bandage and a cold pack",
            "Clean bandage and a cold pack.",
            "Clean bandage and cold pack.",
            "A bandage and a cold pack.",
            "Bandage and a cold pack.",
            "Bandage and cold pack.",
            "The nurse used a clean bandage and a cold pack.",
            "The nurse used a bandage and a cold pack.",
            "She used a clean bandage and a cold pack.",
            "She used a bandage and a cold pack.",
            "A clean bandage.",
            "A cold pack.",
            "What first aid items did the nurse use?",
            "What items did the nurse use?",
            "What did the nurse use?"
          ]
        },
        {
          id: "field_b3",
          topic: "how fast / arrive?",
          cue_prompt: "how fast / nurse arrive?",
          cue_word: "how fast",
          short_label: "how fast / arrive?",
          label: "how fast / nurse arrive?",
          value: "Within two minutes.",
          nova_question: "How fast did the school nurse arrive to help?",
          audio_url: "/audio/week33/info_exchange_q3.mp3",
          answer_audio_url: "/audio/week33/info_exchange_b3_answer.mp3",
          hint: "Your card says the nurse was very quick — how many minutes?",
          acceptable_answers: [
            "Within two minutes.",
            "Within two minutes",
            "Within 2 minutes.",
            "Within 2 minutes",
            "Two minutes.",
            "Two minutes",
            "2 minutes.",
            "2 minutes",
            "In two minutes.",
            "In 2 minutes.",
            "In about two minutes.",
            "In about 2 minutes.",
            "She arrived within two minutes.",
            "She arrived in two minutes.",
            "The nurse arrived within two minutes.",
            "The school nurse arrived within two minutes.",
            "How fast did the school nurse arrive to help?",
            "How fast did the nurse arrive to help?",
            "How fast did the nurse arrive?"
          ]
        },
        {
          id: "field_b4",
          topic: "who / praise?",
          cue_prompt: "who / praise jake?",
          cue_word: "who",
          short_label: "who / praise?",
          label: "who / praise jake?",
          value: "The headmaster praised him in the school assembly.",
          nova_question: "Who praised Jake for his quick action?",
          audio_url: "/audio/week33/info_exchange_q4.mp3",
          answer_audio_url: "/audio/week33/info_exchange_b4_answer.mp3",
          hint: "Who spoke about Jake in front of the whole school?",
          acceptable_answers: [
            "The headmaster praised him in the school assembly.",
            "The headmaster praised him in school assembly.",
            "The headmaster praised Jake in the school assembly.",
            "The headmaster praised Jake in school assembly.",
            "The headmaster praised him.",
            "The headmaster praised Jake.",
            "The headmaster in the school assembly.",
            "The headmaster in school assembly.",
            "The headmaster.",
            "Headmaster Brown in the assembly.",
            "Headmaster Brown in the school assembly.",
            "Headmaster Brown praised Jake.",
            "Headmaster Brown praised him.",
            "Headmaster Brown.",
            "Who praised Jake for his quick action?",
            "Who praised Jake?",
            "Who praised him?"
          ]
        },
        {
          id: "field_b5",
          topic: "what / safety rule?",
          cue_prompt: "what / safety rule?",
          cue_word: "what",
          short_label: "what / safety rule?",
          label: "what / safety rule?",
          value: "Never run in school corridors.",
          nova_question: "What safety rule did the headmaster remind all students?",
          audio_url: "/audio/week33/info_exchange_q5.mp3",
          answer_audio_url: "/audio/week33/info_exchange_b5_answer.mp3",
          hint: "Look at your card — what must students never do inside?",
          acceptable_answers: [
            "Never run in school corridors.",
            "Never run in the school corridors.",
            "Never run in corridors.",
            "Never run in the corridor.",
            "Students must never run in school corridors.",
            "Students must never run in corridors.",
            "Never run inside the school.",
            "Do not run in school corridors.",
            "Don't run in school corridors.",
            "Do not run in corridors.",
            "Don't run in corridors.",
            "Walk carefully and never run inside.",
            "Always walk carefully in corridors.",
            "Walk carefully in school corridors.",
            "What safety rule did the headmaster remind all students?",
            "What safety rule did the headmaster remind students?",
            "What is the safety rule?",
            "What was the safety rule?"
          ]
        }
      ]
    },
    dialogue_script: [
      { speaker: 'woman', text: "Now, let's practice asking and answering questions. Jake and Tom were involved in a school incident. I don't know anything about Jake's first aid action, but you do. So I'm going to ask you some questions." },
      { speaker: 'woman', text: "Where did Jake help his friend?" },
      { speaker: 'man',   text: "Near the science room." },
      { speaker: 'woman', text: "What first aid items did the nurse use?" },
      { speaker: 'man',   text: "A clean bandage and a cold pack." },
      { speaker: 'woman', text: "How fast did the school nurse arrive to help?" },
      { speaker: 'man',   text: "Within two minutes." },
      { speaker: 'woman', text: "Who praised Jake for his quick action?" },
      { speaker: 'man',   text: "The headmaster praised him in the school assembly." },
      { speaker: 'woman', text: "What safety rule did the headmaster remind all students?" },
      { speaker: 'man',   text: "Never run in school corridors." },
      { speaker: 'woman', text: "Now, you don't know anything about Tom's accident, so you ask me some questions." },
      { speaker: 'man',   text: "Where did Tom get injured?" },
      { speaker: 'woman', text: "He slipped in the school corridor near the science lab." },
      { speaker: 'man',   text: "What did he hurt?" },
      { speaker: 'woman', text: "He hurt his right knee when he fell." },
      { speaker: 'man',   text: "When did the accident happen?" },
      { speaker: 'woman', text: "It happened this morning right after science class." },
      { speaker: 'man',   text: "Who helped Tom?" },
      { speaker: 'woman', text: "Jake stopped walking and called the school nurse right away." },
      { speaker: 'man',   text: "How does Tom feel now?" },
      { speaker: 'woman', text: "Tom feels much better now and his knee is recovering well." }
    ]
  },
  picture_story: {
    title: "Jake's School Incident",
    images: [
      {
        id: 1,
        image_url: "/images/week33/ps_1.png",
        narrator_prompt: "Jake was walking carefully down the corridor."
      },
      {
        id: 2,
        image_url: "/images/week33/ps_2.png",
        narrator_prompt: "Suddenly, Tom lost his balance on the wet floor and slipped."
      },
      {
        id: 3,
        image_url: "/images/week33/ps_3.png",
        narrator_prompt: "Jake stopped immediately to help his friend and called the school nurse."
      },
      {
        id: 4,
        image_url: "/images/week33/ps_4.png",
        narrator_prompt: "The nurse arrived quickly with a clean bandage and a cold pack to treat the cut."
      },
      {
        id: 5,
        image_url: "/images/week33/ps_5.png",
        narrator_prompt: "Everyone felt relieved, and the headmaster reminded all students never to run in corridors."
      }
    ],
    examiner_intro: "Look at these five pictures. They tell a story about Jake and a school corridor incident. First, I’ll tell you about picture one. Then you tell me what happens in pictures two, three, four and five.",
    examiner_pic1_narration: "In the first picture, Jake was walking carefully down the school corridor. He noticed the wet floor tiles near the science room."
  },
  personal_questions: {
    examiner_intro: "Now let's talk about you. Please listen to each question and answer clearly.",
    questions: [
      { id: "q1", question: "What's your favorite subject at school?", topic: "school", sample_answer_hint: "My favorite subject is English because I love stories." },
      { id: "q2", question: "What do you usually do on your birthday?", topic: "birthday", sample_answer_hint: "I usually have a party with my family and eat cake." },
      { id: "q3", topic: "family", question: "Tell me about your family.", sample_answer_hint: "There are four people in my family: my parents, my brother, and me." },
      { id: "q4", question: "What did you do last holiday?", topic: "holidays", sample_answer_hint: "Last holiday, I visited the beach with my cousins." }
    ]
  },
  find_differences: {
    picA: {
      title: "Picture A (School Corridor)",
      image_url: "/images/week33/w33_diff_scene_a.jpg"
    },
    picB: {
      title: "Picture B (Corridor Difference)",
      image_url: "/images/week33/w33_diff_scene_b.jpg"
    },
    differences: [
      { id: "d1", name: "Student Bag Color", prompt_en: "In Picture A, the bag on the bench is blue, but in Picture B, it is red.", prompt_vi: "Ở bức tranh A, chiếc cặp trên ghế màu xanh dương, nhưng ở bức tranh B, nó màu đỏ.", x: 9, y: 69 },
      { id: "d2", name: "Potted Plant on Floor", prompt_en: "In Picture A, there is no plant on the floor, but in Picture B, there is a potted plant under the bench.", prompt_vi: "Ở bức tranh A, không có cây dưới sàn, nhưng ở bức tranh B, có một chậu cây dưới ghế.", x: 6, y: 90 },
      { id: "d3", name: "Warning Sign Color", prompt_en: "In Picture A, the caution sign is yellow, but in Picture B, it is orange.", prompt_vi: "Ở bức tranh A, biển cảnh báo màu vàng, nhưng ở bức tranh B, nó màu cam.", x: 30, y: 63 },
      { id: "d4", name: "Boy's T-shirt Color", prompt_en: "In Picture A, the boy walking is wearing a red T-shirt, but in Picture B, he is wearing a blue T-shirt.", prompt_vi: "Ở bức tranh A, cậu bé mặc áo phông đỏ, nhưng ở bức tranh B, cậu bé mặc áo phông xanh dương.", x: 50, y: 61 },
      { id: "d5", name: "Hanging Coat Color", prompt_en: "In Picture A, the coat hanging on the wall is red, but in Picture B, it is green.", prompt_vi: "Ở bức tranh A, chiếc áo khoác treo trên tường màu đỏ, nhưng ở bức tranh B, nó màu xanh lá.", x: 73, y: 53 },
      { id: "d6", name: "Wall Clock Time", prompt_en: "In Picture A, the clock shows nine o'clock, but in Picture B, it shows ten o'clock.", prompt_vi: "Ở bức tranh A, đồng hồ chỉ 9 giờ, nhưng ở bức tranh B, đồng hồ chỉ 10 giờ.", x: 61, y: 20 }
    ]
  }
};

export const speakingHubData = speakingHub;
export default speakingHub;
